import React, { Component } from 'react';
import DoubleNavigationPage from './jd-main';


import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <DoubleNavigationPage/>
      </div>
    );
  }
}

/// ////////////////////////////////////////////////////////
export default App;



// WEBPACK FOOTER //
// ./src/App.js